import React from "react";
import { Avatar, AvatarFallback } from "@focal/ui-kit";
import { UserIcon } from "@focal/ui-kit";
import { getFirstLetter } from "@/lib";
import { cn } from "@/lib/utils";
import * as AvatarPrimitive from "@radix-ui/react-avatar";

interface AvatarComponentProps {
  name?: string;
  className?: string;
}

const AvatarComponent = ({
  name,
  className,
  ...props
}: AvatarComponentProps &
  React.ComponentPropsWithoutRef<typeof AvatarPrimitive.Root>) => {
  const [firstName = "", lastName = ""] = name?.split(" ") || [];

  return (
    <Avatar className={cn("cursor-pointer", className)} {...props}>
      <AvatarFallback className="bg-blue-100 text-typography-primary">
        {firstName ? (
          `${getFirstLetter(firstName).toUpperCase()}${lastName && getFirstLetter(lastName).toUpperCase()}`
        ) : (
          <UserIcon className="fill-typography-primary w-5 h-5" />
        )}
      </AvatarFallback>
    </Avatar>
  );
};

export default AvatarComponent;
